var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTagSelector)?_c('tag-selector',{attrs:{"active-tag":_vm.activeTag,"clearable":""},on:{"update":_vm.onTagUpdate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }